const ROLES = {
  ABGW_PRIVATE: 'Backup (ABGW) private',
  ABGW_PUBLIC: 'Backup (ABGW) public',
  COMPUTE_API: 'Compute API',
  COMPUTE_PRIVATE: 'VM private',
  COMPUTE_PUBLIC: 'VM public',
  CONNECTIVITY: 'Connectivity checking',
  ISCSI: 'iSCSI',
  MANAGEMENT: 'Internal management',
  MANAGEMENT_PANEL: 'Admin panel',
  NBD: 'VM backups',
  NFS: 'NFS',
  OSTOR_PRIVATE: 'OSTOR private',
  S3_PUBLIC: 'S3 public',
  SELF_SERVICE: 'Self-service panel',
  SNMP: 'SNMP',
  SSH: 'SSH',
  STORAGE: 'Storage',
  SMB: 'SMB'
};

export const ROLES_WITH_FIREWALL_RULES = [
  ROLES.S3_PUBLIC,
  ROLES.NFS,
  ROLES.ABGW_PUBLIC,
  ROLES.ISCSI,
  ROLES.MANAGEMENT_PANEL,
  ROLES.SELF_SERVICE,
  ROLES.SNMP,
  ROLES.SSH
];

export const ROLE_TYPES = {
  ALL: 'all',
  CUSTOM: 'custom',
  PREDEFINED: 'predefined',
};

export const HA_ROLES = [
  ROLES.MANAGEMENT,
  ROLES.MANAGEMENT_PANEL
];

export const MIGRATION_BLOCKED_ROLES_WHEN_HA_ENABLED = [
  ROLES.MANAGEMENT,
  ROLES.COMPUTE_API
];

export const STORAGE_ROLES = [
  ROLES.STORAGE,
  ROLES.MANAGEMENT,
  ROLES.OSTOR_PRIVATE,
  ROLES.ABGW_PRIVATE,
  ROLES.SMB
];

export const COMPUTE_ROLES = [
  ROLES.COMPUTE_PRIVATE,
  ROLES.COMPUTE_PUBLIC,
  ROLES.COMPUTE_API,
  ROLES.NBD,
];

export const VHS_ROLES = [
  ROLES.COMPUTE_API,
  ROLES.COMPUTE_PUBLIC,
];

export const ENCRYPTION_ROLES = [
  ROLES.MANAGEMENT,
  ROLES.COMPUTE_PRIVATE,
  ROLES.NBD,
  ROLES.STORAGE,
  ROLES.OSTOR_PRIVATE
];

export const ENCRYPTION_ROLES_BY_DEFAULT = [
  ROLES.ABGW_PRIVATE
];

export const ABGW_ROLES = [
  ROLES.ABGW_PRIVATE,
  ROLES.ABGW_PUBLIC
];

export const S3_ROLES = [
  ROLES.OSTOR_PRIVATE,
  ROLES.S3_PUBLIC
];

export const NFS_ROLES = [
  ROLES.OSTOR_PRIVATE,
  ROLES.NFS
];

export const SMB_ROLES = [
  ROLES.SMB
];

export default ROLES;
